import React from 'react';
import SvgIconLoader, { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-loader';

import TextInfo, {
  COLOR,
  FONT_TYPE,
  SIZE,
  KIND_TEXT,
  SEGMENT,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Button, {
  BUTTON_COLOR,
  SEGMENT as BUTTON_SEGMENT,
} from '@bit/gerenciatd.unifiedcomponents.button';

import '../VideoBanner.scss';

export const COMPONENT_NAME = 'banner';

const ContainerText = ({
  claim, subClaim, title, button,
}) => {
  return (
    <div className="VideoBanner__wrapper container">
      <div className="VideoBanner__wrapper__texts">
        <div className="playBanner">
          <SvgIconLoader
            kind={SVG_ICON_KIND.MEDIUM}
            segment={SEGMENT.EMP}
            backgroundColor={COLOR.TRANSPARENT}
            size={50}
            id="Play"
            color={COLOR.WHITE}
          />
          <TextInfo
            kind={KIND_TEXT.PARAGRAPH}
            size={SIZE.CAPTION2}
            fontType={FONT_TYPE.LIGHT}
            align="center"
            color={COLOR.WHITE}
            text="Ver video"
            segment={SEGMENT.EMP}
            className="margin-left"
          />
        </div>
        <TextInfo
          kind={KIND_TEXT.PARAGRAPH}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.REGULAR}
          color={COLOR.WHITE}
          text={title}
          segment={SEGMENT.EMP}
          className="VideoBanner__wrapper__texts__text"
          tabletProps={{
            size: SIZE.CAPTION1,
          }}
        />
        <TextInfo
          kind={KIND_TEXT.PARAGRAPH}
          size={SIZE.TITLE3}
          fontType={FONT_TYPE.LIGHT}
          color={COLOR.WHITE}
          text={claim}
          segment={SEGMENT.EMP}
          className="VideoBanner__wrapper__texts__text"
          tabletProps={{
            size: SIZE.DISPLAY2,
          }}
        />
        <TextInfo
          kind={KIND_TEXT.PARAGRAPH}
          size={SIZE.CAPTION1}
          fontType={FONT_TYPE.LIGHT}
          color={COLOR.WHITE}
          text={subClaim}
          segment={SEGMENT.EMP}
          className="VideoBanner__wrapper__texts__button"
          tabletProps={{
            size: SIZE.TITLE5,
          }}
        />
        {
          button !== ''
          && (
          <Button
            segment={BUTTON_SEGMENT.EMP}
            label={button}
            buttonType="button"
            onClick={handleModal}
            taggingInfo={{
              componentContent: button,
              componentProduct: '',
              componentVariation: 'all',
              componentName: COMPONENT_NAME,
            }}
            color={BUTTON_COLOR.WHITE_BLUE}
            font="bold"
            border="no-border-radius"
            size={{
              w: 'full',
              h: 'large',
            }}
            tabletProps={{
              size: {
                w: 'liquid',
              },
            }}
            desktopProps={{
              size: {
                w: 'liquid',
              },
            }}
          />
          )
        }
      </div>
    </div>
  );
};

export default ContainerText;
